import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/traversal/add/add.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/utils/each/each.js";
import "dabbyjs/src/utils/extend/extend.js";
import compileTemplate from "./compile-template.js";
import importscript from "./import-script.js";

// https://snazzymaps.com/
// const theme = [
// 	{
// 		featureType: "all",
// 		elementType: "labels.text",
// 		stylers: [
// 			{
// 				color: "#878787"
// 			}
// 		]
// 	},
// 	{
// 		featureType: "all",
// 		elementType: "labels.text.stroke",
// 		stylers: [
// 			{
// 				visibility: "off"
// 			}
// 		]
// 	},
// 	{
// 		featureType: "landscape",
// 		elementType: "all",
// 		stylers: [
// 			{
// 				color: "#f9f5ed"
// 			}
// 		]
// 	},
// 	{
// 		featureType: "road.highway",
// 		elementType: "all",
// 		stylers: [
// 			{
// 				color: "#f5f5f5"
// 			}
// 		]
// 	},
// 	{
// 		featureType: "road.highway",
// 		elementType: "geometry.stroke",
// 		stylers: [
// 			{
// 				color: "#c9c9c9"
// 			}
// 		]
// 	},
// 	{
// 		featureType: "water",
// 		elementType: "all",
// 		stylers: [
// 			{
// 				color: "#aee0f4"
// 			}
// 		]
// 	}
// ];

export default obj => {
	if (obj.length) {		
		const render = () => {
			obj.each(function () {
				const $this = $(this),
					input = $this.is("input"),
					container = input ? $("<div>", {
						"class": $this.attr("class").split(" ")[0] + "-map"
					}).insertBefore($this).get(0) : this,
					config = $.extend({
						heatmap: false,
						popup: null,
						data: [],
						centre: {
							lat: 50.706788917614276,
							lng: -3.4890598973587084
						},
						radius: 20,
						colours: ["#1f396f", "#d62330"],
						geocode: []
					}, $this.data("map")),
					centre = new google.maps.LatLng(config.centre.lat, config.centre.lng),
					map = new google.maps.Map(container, {
						zoom: 8,
						streetViewControl: false,
						center: centre,
						// styles: theme
					}),
					bounds = new google.maps.LatLngBounds(),
					infowindow = new google.maps.InfoWindow(),
					icon = {
						path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
						anchor: new google.maps.Point(12,17),
						fillOpacity: 1,
						fillColor: config.colours[1],
						strokeWeight: 2,
						strokeColor: "white",
						scale: 1.8,
						labelOrigin: new google.maps.Point(12,15)
					};

				// we provided markers
				if (config.data.length) {

					// add heatmap data
					if (config.heatmap) {
						const heatmap = new google.maps.visualization.HeatmapLayer({
							radius: config.radius,
							data: config.data.map(({lat, lng, weight}) => {
								const loc = new google.maps.LatLng(lat, lng);
								return weight ? {location: loc, weight: weight} : loc;
							})
						});
						heatmap.setMap(map);
						heatmap.set("opacity", 0.8);

						google.maps.event.addListener(map, "zoom_changed", () => {
							heatmap.set("radius", map.getZoom() * 2);
							// heatmap.set("maxIntensity", map.getZoom() > 13 ? 1 : null);
						});
					}

					$.each(config.data, (i, item) => {
						const latlng = new google.maps.LatLng(item.lat, item.lng);
						bounds.extend(latlng);
						if (!config.heatmap) { // don't set markers if heatmap
							icon.fillColor = item.colour || config.colours[1];
							const marker = new google.maps.Marker({
								map: map,
								position: latlng,
								icon: icon,
								label: item.label
							});
							if (config.popup) {
								google.maps.event.addListener(marker, "click", e => {

									// close current window
									infowindow.close();

									// zoom in on marker
									map.setZoom(10);
									map.panTo(latlng);

									// set new window content
									infowindow.setPosition(latlng);

									// Set dialog box content
									infowindow.setContent(compileTemplate(item, config.popup));
									infowindow.open(map);
								});
							}
						}
					});
					map.fitBounds(bounds);

					// have to add event listener to reset the zoom
					const listener = google.maps.event.addListener(map, "idle", () => {
						if (map.getZoom() > 10) {
							map.setZoom(10);
						}
						google.maps.event.removeListener(listener);
					});

				// we want to input the location ourselves
				} else if (input) {
					const getVal = obj => {
						const val = obj.val();
						if (val && /^-?\d{1,3}(?:\.\d{1,19})?,-?\d{1,3}(?:\.\d{1,19})?$/.test(val)) {
							const [lat, lng] = val.split(",");
							return new google.maps.LatLng(lat, lng);
						}
						return null;
					},
						drop = () => {
							const pos = marker.getPosition();
							$this.val(pos.lat() + "," + pos.lng());
							icon.fillColor = config.colours[1];
							marker.setIcon(icon);
						},
						value = getVal($this),
						search = config.geocode.reduce((controls, item) => controls.add($("[name=" + item + "]")), $()),
						setSearch = (map, marker, search) => {

							// get query text from controls
							let query = [];
							search.each(function () {
								const val = $(this).val();
								if (val) {
									if (this.tagName === "SELECT") {
										const option = $("option[value='"+val+"']", this),
											parent = option.parent("optgroup").attr("label");
										query.push(option.text());
										if (parent) {
											query.push(parent);
										}
									} else {
										query.push(val);
									}
								}
							});

							// geocode the query and update the map
							if (query.length) {
								const geo = new google.maps.Geocoder();
								geo.geocode({address: query.join(", ")}, (results, status) => {
									if (status === "OK" && results[0]) {
										const location = results[0].geometry.location;
										map.setCenter(location);
										marker.setPosition(location);
										marker.setTitle(results[0].formatted_address);
										map.setZoom(10);
									}
								});
							}
						};

					// Create marker
					icon.fillColor = config.colours[value ? 1 : 0];
					const marker = new google.maps.Marker({
						position: value || centre,
						draggable: true,
						map: map,
						icon: icon
					});

					// centre map
					if (value !== null) {
						map.setCenter(value);
						map.setZoom(10);
					} else if (search.length) {
						setSearch(map, marker, search);
					}

					// make the marker draggable
					google.maps.event.addListener(marker, "dragend", drop);

					// make the marker draggable
					google.maps.event.addListener(marker, "dblclick", () => {
						const latlng = getVal($this);
						if (latlng === null) {
							drop();
						} else {
							$this.val("");
							icon.fillColor = config.colours[0];
							marker.setIcon(icon);
						}
					});

					// search when finished typing
					let timer = null;
					search.on("change", () => {
						if (!obj.val()) {
							clearTimeout(timer);
							timer = setTimeout(() => setSearch(map, marker, search), 5000);
						}
					});
				}
			});
		};

		// load the map script
		if (typeof google === "undefined" || typeof google.maps === "undefined" || typeof google.maps.Map === "undefined") {
			window.initmap = render;
			const params = {
				language: $("html").attr("lang") || "en",
				loading: "async",
				callback: "initmap"
			};

			// get API key and heatmap setting
			obj.each((i, item) => {
				const config = $(item).data("map");
				if (!params.key && config.apikey) {
					params.key = config.apikey;
				}
				if (config.heatmap) {
					params.libraries = "visualization";
					return false;
				}
			});

			// compile language
			if (params.language.includes("-")) {
				const lang = params.language.split("-");
				params.language = lang[0];
				params.region = lang[1];
			}

			// include script
			importscript("https://maps.googleapis.com/maps/api/js?" + new URLSearchParams(params));
		} else {
			render();
		}
	}
};
